import React from 'react';
import { Avatar } from 'components';

const MessageTile = ({ data, isSelected, onClick }) => {
  const { username, time, message, avatar, isLive = true } = data;
  return (
    <div
      className={`message-tile ${isSelected ? 'message-tile--selected' : ''}`}
      onClick={onClick}
    >
      <Avatar
        src={avatar}
        name={username}
        size='md'
        isOnline={isLive}
        hasBorder={false}
      />
      <div className='message-tile__content'>
        <div className='message-tile__header'>
          <span className='message-tile__username'>{username}</span>
          <span className='message-tile__time'>{time}</span>
        </div>
        <div className='message-tile__preview'>{message}</div>
      </div>
    </div>
  );
};

export default MessageTile;
